import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

import {AppNavLinks} from "./AppNavlinks";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import {useLocation} from "react-router";
import {useModalsStore} from "../../stores/modalsStore";

export const barHeight = 56


export const AppMobileNav = () => {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [isClosing, setIsClosing] = React.useState(false);
    let location = useLocation();

    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    const closeAllModals = useModalsStore((state) => state.closeAllModals)

    useDidMountEffect(function closeNavOnPageChange(){
        setMobileOpen(false)
        closeAllModals()
    }, [location.pathname]);

    return (
        <Box sx={{ display: 'flex'}}>
            <AppBar
                position="fixed"
                className={'MobileAppBar'}
                style={{ height: barHeight }}
            >
                <Toolbar className={'mobile-toolbar'}>
                    <img src={"https://res.cloudinary.com/hgjsxpz9b/image/upload/v1765310173/Asset_4_4x-8_teyqav.png"} alt="Logo" style={{ width: '300px'}} />

                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                    >
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Box component="nav" style={{ top: barHeight, position: 'relative' }}>
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onTransitionEnd={handleDrawerTransitionEnd}
                    onClose={handleDrawerClose}
                    anchor={'top'}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    <AppNavLinks/>
                </Drawer>
            </Box>
        </Box>
    );
}